import { Box, Button, ButtonGroup } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { ElevionLogicalOperator } from 'utils/elevion';

type Props = {
  activeOp: ElevionLogicalOperator;
  readOnly?: boolean;
  parentName?: string;
};

// The supported logical operators.
const logicalOperators: ElevionLogicalOperator[] = ['AND', 'OR'];

export const ElevionLogicalOp = ({
  activeOp,
  readOnly,
  parentName,
}: Props): JSX.Element => {
  const { setValue } = useFormContext();

  const handleOperatorClick = useCallback(
    (operator) => {
      setValue(`${parentName}.logicalOp`, operator);
    },
    [parentName, setValue],
  );

  return (
    <Box margin="200 0 200 200">
      <ButtonGroup>
        {logicalOperators.map((operator) => (
          <Button
            key={operator}
            variant={operator === activeOp ? 'primary' : 'secondary'}
            disabled={readOnly}
            onClick={
              operator === activeOp
                ? undefined
                : () => handleOperatorClick(operator)
            }
          >
            {operator}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};
